import { ADMIN_RESOURCE_REGISTRY as BASE_ADMIN_RESOURCE_REGISTRY } from './admin-resource.registry.js';
import { OPERATION_IDS, ROUTE_IDS } from '../routes/ids.js';
import { PLATFORM_MODULE_ASSIGNMENT_EDIT_FORM } from '../descriptors/platform-module-assignment-forms.js';
const platformOrganizations = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-organizations'],
    tableDescriptorId: 'table.admin.platformOrganizations',
    deleteOperationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_DISABLE,
    deleteCommandId: 'cmd.admin.platform-organizations.disable',
    kind: 'standard-list-form',
});
const platformUsers = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-users'],
    tableDescriptorId: 'table.admin.platformUsers',
    formDescriptorId: 'form.admin.platformUser',
    kind: 'standard-list-form',
    rowActivation: 'DETAIL',
});
const platformModules = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-modules'],
    tableDescriptorId: 'table.admin.platformModules',
    formDescriptorId: PLATFORM_MODULE_ASSIGNMENT_EDIT_FORM.id,
    listQueryId: 'query.platform-admin.modules.list',
    // The historical detail route is the canonical configure route for a
    // concrete assignment. Keeping it out of detail resolution ensures the web
    // runtime selects the generic edit form rather than a read-only detail page.
    detailRouteId: undefined,
    editRouteId: ROUTE_IDS.PLATFORM_MODULES_DETAIL,
    kind: 'standard-list-form',
    rowActivation: 'NONE',
});
const platformAudit = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-audit'],
    tableDescriptorId: 'table.admin.platformAudit',
    kind: 'read-only-list',
    rowActivation: 'DETAIL',
});
const platformAccessInspector = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-access-inspector'],
    tableDescriptorId: 'table.admin.platformAccessInspector',
    kind: 'read-only-list',
    rowActivation: 'NONE',
});
const supportDelegation = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['platform-support-delegations'],
    tableDescriptorId: 'table.admin.platformSupportDelegations',
    formDescriptorId: 'form.admin.platformSupportDelegation',
    updateOperationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
    updateCommandId: 'cmd.admin.platform-support-delegations.revoke',
    kind: 'standard-list-form',
    rowActivation: 'DETAIL',
});
const organizationBranches = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['organization-branches'],
    // A branch is a first-class record with an authorized read route. Row
    // activation must therefore use the same generic detail path as other
    // standard list/form resources instead of behaving as an inert table row.
    rowActivation: 'DETAIL',
});
const organizationOpeningCutover = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['organization-opening-cutover'],
    listQueryId: 'query.admin.organization-opening-cutover.list',
    readQueryId: 'query.admin.organization-opening-cutover.get',
    createCommandId: 'cmd.admin.organization-opening-cutover.preview',
    updateCommandId: 'cmd.admin.organization-opening-cutover.preview',
    formDescriptorId: 'form.admin.openingCutover',
    kind: 'standard-list-form',
    rowActivation: 'DETAIL',
});
const organizationTaxRules = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['organization-tax-rules'],
    listQueryId: 'query.admin.tax-rules.list',
    readQueryId: 'query.admin.tax-rules.get',
    createOperationId: OPERATION_IDS.TAX_RULE_CREATE_VERSION,
    updateOperationId: OPERATION_IDS.TAX_RULE_CREATE_VERSION,
    createCommandId: 'cmd.admin.tax-rules.create-version',
    updateCommandId: 'cmd.admin.tax-rules.create-version',
    formDescriptorId: 'form.admin.taxRule',
    kind: 'standard-list-form',
    rowActivation: 'DETAIL',
});
const organizationFeeRules = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY['organization-fee-rules'],
    listQueryId: 'query.admin.fee-rules.list',
    readQueryId: 'query.admin.fee-rules.get',
    createOperationId: OPERATION_IDS.FEE_RULE_CREATE_VERSION,
    updateOperationId: OPERATION_IDS.FEE_RULE_CREATE_VERSION,
    createCommandId: 'cmd.admin.fee-rules.create-version',
    updateCommandId: 'cmd.admin.fee-rules.create-version',
    formDescriptorId: 'form.admin.feeRule',
    kind: 'standard-list-form',
    rowActivation: 'DETAIL',
});
export const ADMIN_RESOURCE_REGISTRY = Object.freeze({
    ...BASE_ADMIN_RESOURCE_REGISTRY,
    'platform-organizations': platformOrganizations,
    'platform-users': platformUsers,
    'platform-modules': platformModules,
    'platform-audit': platformAudit,
    'platform-access-inspector': platformAccessInspector,
    'platform-support-delegations': supportDelegation,
    'organization-branches': organizationBranches,
    'organization-opening-cutover': organizationOpeningCutover,
    'organization-tax-rules': organizationTaxRules,
    'organization-fee-rules': organizationFeeRules,
});
export function getAdminResourceDescriptor(id) {
    return ADMIN_RESOURCE_REGISTRY[id];
}
/**
 * Alias for the effective admin resource registry, used by tests that need to
 * distinguish the effective (platform-overlaid) registry from the base one.
 */
export const EFFECTIVE_ADMIN_RESOURCE_REGISTRY = ADMIN_RESOURCE_REGISTRY;
